import React from "react";
import { useTranslation } from "react-i18next";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

/**
 * Shown on Planning / Training when the user is in view-only mode (e.g. player).
 */
export function SessionReadOnlyBanner({ page = "planning" }) {
  const { t } = useTranslation();
  const title =
    page === "training"
      ? t("sessionReadOnlyTrainingTitle") || "Training — view only"
      : t("sessionReadOnlyPlanningTitle") || "Planning — view only";
  const hint =
    page === "training"
      ? t("sessionReadOnlyTrainingHint") ||
        "You can follow exercises, tables, and results. Coaching controls are hidden."
      : t("sessionReadOnlyPlanningHint") ||
        "You can view the session plan, scores, and summaries. Editing is disabled.";

  return (
    <div className="session-readonly-banner" role="status">
      <VisibilityOutlinedIcon className="session-readonly-banner__icon" />
      <div className="session-readonly-banner__text">
        <strong>{title}</strong>
        <span>{hint}</span>
      </div>
    </div>
  );
}

export default SessionReadOnlyBanner;
